module.exports = {"latin":[{"family":"Montserrat","url":"//is4.fwrdassets.com/fw/font/montserrat-regular-webfont"}]}


//////////////////
// WEBPACK FOOTER
// ./styleguide/src/data/fonts.json
// module id = 298
// module chunks = 4